import { DataGrid, GridColDef, GridLocaleText, DataGridProps, GridColumnMenu, GridColumnMenuProps } from "@mui/x-data-grid";
import { enUS, zhHK } from "@mui/x-data-grid/locales";
import React from "react";
import { useTranslation } from "react-i18next";
import language from "services/lang";

interface TableProps extends DataGridProps {
	columns: GridColDef[];
	rows: any[];
	handleChange: Function;
}

const Table: React.FC<TableProps> = ({ columns, rows, handleChange, ...dataGridProps }) => {
	const { t } = useTranslation(["common"]);
	const localeText = React.useMemo<Partial<GridLocaleText>>(() => {
		if (language === "en") {
			return enUS.components.MuiDataGrid.defaultProps.localeText;
		} else if (language === "zh") {
			return zhHK.components.MuiDataGrid.defaultProps.localeText;
		}
	}, [language]);

	function CustomColumnMenu(props: GridColumnMenuProps) {
		return (
			<GridColumnMenu
				{...props}
				slots={{
					// Hide `columnMenuColumnsItem`
					columnMenuColumnsItem: null,
				}}
			/>
		);
	}

	return (
		<DataGrid
			columns={columns}
			rows={rows}
			initialState={{
				pagination: { paginationModel: { pageSize: 10 } },
			}}
			pageSizeOptions={[10, 25, 50, 100, { value: -1, label: t("all") }]}
			localeText={localeText}
			slots={{
				columnMenu: CustomColumnMenu,
			}}
			{...dataGridProps}
		/>
	);
};

export default Table;
